module.exports = __webpack_public_path__ + "static/savings-card-d21ddbf0a612c16653812b8332087380.png";